var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('post-back',{attrs:{"title":_vm.content[_vm.lang].title}}),_c('div',{staticClass:"padding-60"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.content[_vm.lang].text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }